import { Typography } from "@quint/ui";
import { Result } from "./icons/result";
import { SmartRandomness } from "./icons/smart-randomness";
import { TicketAllocation } from "./icons/ticket-allocation";
import { TransparentProcess } from "./icons/transparent-process";
import { Section } from "./section";
import { SvgDefs } from "./svg-defs";

const sections = [
  {
    Icon: TransparentProcess,
    title: "Transparent Process",
    description: "Ticket list from smart contract published to IPFS for transparency",
  },
  {
    Icon: SmartRandomness,
    title: "Smart Randomness",
    description: (
      <>
        <Typography variant="baseRegular" className="text-slate-700 dark:text-[#B3BAC0]">
          <a href="https://bscscan.com/address/0xC95C7522c2800B96f3843321D8879e770A076dC9#code">Smart contract</a>{" "}
          deployed using Chain Link VRF to generate a random number
        </Typography>
      </>
    ),
  },
  {
    Icon: TicketAllocation,
    title: "Ticket Allocation",
    description: "Random number determines ticket ID and associated wallet",
  },
  {
    Icon: Result,
    title: "Result",
    description: "The winner is announced",
  },
];

export const OnChainDraw = () => {
  return (
    <div className="my-20">
      <SvgDefs />
      <Typography variant="h3" className="text-center">
        On Chain Draw
      </Typography>

      <div className="mt-10 grid gap-16 px-10 md:grid-cols-2 xl:grid-cols-4 xl:px-14">
        {sections.map((section) => (
          <Section key={section.title} {...section} />
        ))}
      </div>
    </div>
  );
};
